<div class="filter-modal">
    <div class="filter-modal__title">
        <h3>
            {{ 'filter-modal.filterResultCount' | content: {
                TOTAL: previewTotal ? previewTotal : total,
                TYPE: mode === 'opleiding' ? 'opleidingen' : 'functies'
            } }}
        </h3>
        <mat-icon matRipple (click)="close()">close</mat-icon>
    </div>

    <div *ngFor="let filter of filters; let filterIndex = index" class="item-container">
        <app-accordion-compact [open]="true">
            <h2 accordionHeader>{{ filter.naam }}</h2>
            <ng-container accordionBody>

            <div class="checkbox"
                 *ngIf="filter.type === 'keuzelijst' && filter.optieSets.length === 1"
                 [ngStyle]="{
                    'grid-template-rows': 'repeat(' + calculateItemAmountInColumn(filter.optieSets[0].opties.length) + ', auto)'
                 }">
                <mat-checkbox *ngFor="let option of filter.optieSets[0].opties"
                            color="primary"
                            [name]="filter.zoekVeld"
                            [checked]="option.checked"
                            (change)="handleOptionToggle($event, filter.zoekVeld, option.value)"
                            [value]="option.value">
                    <div class="checkbox-value">{{option.value}}</div>
                </mat-checkbox>
            </div>

            <div class="checkbox-group" *ngIf="filter.type === 'keuzelijst' && filter.optieSets.length > 1">
                <div class="checkbox-group__optionset" *ngFor="let optionSet of filter.optieSets">
                    <h5>{{optionSet.naam}}</h5>
                    <div class="checkbox-group__optionset__checkbox">
                        <mat-checkbox *ngFor="let option of optionSet.opties"
                                      color="primary"
                                      [name]="filter.zoekVeld"
                                      [checked]="option.checked"
                                      (change)="handleOptionToggle($event, filter.zoekVeld, option.value)"
                                      [value]="option.value">
                            <span class="checkbox-value">{{option.value}}</span>
                        </mat-checkbox>
                    </div>
                </div>
            </div>

            <div class="filter-modal__range" *ngIf="filter.type === 'interval'">
                <div class="filter-modal__range--ondergrens">

                    <p>{{'filter-modal.ondergrens' | content}}</p>
                    <div class="filter-modal__range__container">
                      <mat-icon class="material-icons">euro</mat-icon>
                      <p>{{filter.optieSets[0].opties[0].value}}</p>

                      <mat-slider
                              [min]="filter.optieSets[0].opties[0].value"
                              [max]="filter.optieSets[0].opties[1].value"
                              [step]="100"
                              [thumbLabel]="true"
                              [tickInterval]="100"
                              [(ngModel)]="filter.ondergrens"
                              [value]="rangeValueForPreview"
                              (change)="handleRangeSelection(filter.ondergrens, filter.bovengrens)">
                      </mat-slider>

                      <mat-icon class="material-icons">euro</mat-icon>
                      <p>{{filter.optieSets[0].opties[1].value}}</p>
                    </div>

                    </div>
                </div>
            </ng-container>
        </app-accordion-compact>
    </div>

  <div class="filter-modal__button__container">
    <button (click)="doFilter()" class="filter-modal__button">
        {{'filter-modal.showResults' | content: {
           TOTAL: previewTotal !== undefined ? previewTotal : total
         } }}
    </button>
    <button (click)="resetFilters()" class="filter-modal__button">
      {{'filter-modal.resetFilters' | content}}
    </button>
  </div>
</div>
